import api from './apiService';  
import apiRoutes from './apiRoutes';

// get subordinates list 
export const getSubordinateToEvaluateAsync = async () => {
    try {
      const response = await api.get(apiRoutes.getSubordinateToEvaluate);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  // Get all past evaluations
  export const getAllMyPastEvaluationsAsync = async () => {
    try {
      const response = await api.get(apiRoutes.getAllMyPastEvaluations);
      return response.result;
    } catch (error) {
      throw error
    }
  };
 
  export const getAllArchiveEvaluationsAsync = async () => {
    try {
      const response = await api.get(apiRoutes.getAllArchiveEvaluations);
      return response.result;
    } catch (error) {
      throw error
    }
  };
 

 
  // get subordinate info :
  export const getSubordinateEvaluationAsync = async (hierId) => {
    try {
      const response = await api.get(apiRoutes.getSubordinateEvaluation(hierId));
      return response.result;
    } catch (error) {
      throw error
    }
  };
  
  export const getMyEvaluationDetailsAsync = async (empEvalId) => {
    try {
      const response = await api.get(apiRoutes.getMyEvaluationDetails(empEvalId));
      return response.result;
    } catch (error) {
      throw error
    }
  };
  

export const getEvaluationItemsAsync = async (subEmpId) => {
    try {
      const response = await api.get(apiRoutes.getEvaluationItems(subEmpId));
      return response.result;
    } catch (error) {
      throw error
    }
  };
  
  export const createNewEvaluationAsync = async (subEmpId, payload) => {
    try {
        const response = await api.post(apiRoutes.createEvaluation(subEmpId), payload);
      return response.result;
    } catch (error) {
      throw error
    }
  };


  export const updateEvaluationAsync = async (subEmpId, payload) => {
    try {
        const response = await api.put(apiRoutes.updateEvaluation(subEmpId), payload);
      return response.result;
    } catch (error) {
      throw error
    }
  };
   
  